export default [
    {
      path: '/admin/sale-areas',
      name: 'sale-area',
      meta: { requiresAuth: true },
      component: () => import('@/pages/sale/sale-area/index.vue')
    }
  ]